import useTenant from '@/hooks/useTenant'
import { useFeatureFlag as useFlagCore, type EvalContext } from '@caterdesk/flags-react'

export enum SPLITS {
  USE_NEW_SAVED_ADDRESSED = 'NewGmSavedAddresses',
  REMOVE_ITEM_NOTES = 'removeItemNotes',
  BUDGET_CODE_MANDATORY = 'GmMandatoryBudgetCode',
  EATFIRST_ISSUES_NOTICE = 'EatfirstIssuesNotice',
  SHOW_CONTACT_ASSIGNMENT_CHECKOUT = 'showContactAssignmentGmCheckout',
  TURN_OFF_DEFAULT_INVOICE_ACCOUNT = 'turnOffDefaultInvoiceAccount',
  MIX_PANEL_INDIVIDUAL_EVENTS = 'MixpanelIndividualEvents',
}

export const useFeatureFlag = (
  flagKey: SPLITS,
  attributes: EvalContext['attributes'] = {},
): boolean => {
  const tenant = useTenant()
  return useFlagCore(flagKey, {
    attributes: { ...attributes, tenantId: tenant.id },
  })
}
